var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.92,143.68l9.67,6,1.83-3a2.69,2.69,0,0,1,2.54-1.25,16.09,16.09,0,0,0,1.7,0,2.72,2.72,0,0,1,2.46,1.41l1.64,3.07,10-5.38-1.65-3.06a2.72,2.72,0,0,1,.18-2.83,14.55,14.55,0,0,0,.9-1.45,2.72,2.72,0,0,1,2.45-1.42l3.48.11.36-11.37-3.5-.1a2.71,2.71,0,0,1-2.35-1.59c-.12-.25-.24-.5-.38-.74s-.27-.49-.41-.73a2.7,2.7,0,0,1,0-2.83l1.85-3-9.67-6-1.84,3a2.72,2.72,0,0,1-2.54,1.26,16.1,16.1,0,0,0-1.7-.06,2.7,2.7,0,0,1-2.45-1.41l-1.64-3.07-10,5.38,1.65,3.07a2.69,2.69,0,0,1-.19,2.82,15,15,0,0,0-.89,1.44,2.7,2.7,0,0,1-2.45,1.43l-3.49-.11-.35,11.37,3.49.1A2.73,2.73,0,0,1,414,136.4c.12.25.24.5.38.75s.27.49.41.73a2.7,2.7,0,0,1,0,2.83Zm7.18-9.63a9.31,9.31,0,1,1,12.61,3.82A9.3,9.3,0,0,1,420.1,134.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.3,204.56l4,6.91,2.12-1.23a1.91,1.91,0,0,1,2,.07,10.62,10.62,0,0,0,1,.6,1.89,1.89,0,0,1,1,1.68V215h8v-2.44a1.89,1.89,0,0,1,1.05-1.68,10.62,10.62,0,0,0,1-.6,1.92,1.92,0,0,1,2-.07l2.11,1.23,4-6.91-2.12-1.22a1.89,1.89,0,0,1-.93-1.75c0-.2,0-.39,0-.59s0-.39,0-.59a1.88,1.88,0,0,1,.92-1.75l2.13-1.23-4-6.9-2.12,1.22a1.88,1.88,0,0,1-2-.07c-.33-.21-.67-.41-1-.59a1.9,1.9,0,0,1-1.05-1.68V187h-8v2.44a1.9,1.9,0,0,1-1,1.68c-.35.18-.69.38-1,.59a1.88,1.88,0,0,1-2,.07l-2.12-1.22-4,6.9,2.12,1.23a1.86,1.86,0,0,1,.92,1.75c0,.19,0,.39,0,.59s0,.39,0,.59a1.87,1.87,0,0,1-.92,1.75Zm7.62-3.56a6.53,6.53,0,1,1,6.52,6.53A6.52,6.52,0,0,1,448.92,201Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.41,329.59l4,6.9,2.11-1.22a1.9,1.9,0,0,1,2,.06,10.62,10.62,0,0,0,1,.6,1.89,1.89,0,0,1,1,1.68v2.44h8v-2.44a1.89,1.89,0,0,1,1.05-1.68,10.62,10.62,0,0,0,1-.6,1.88,1.88,0,0,1,2-.06l2.12,1.22,4-6.9-2.12-1.23a1.86,1.86,0,0,1-.93-1.75c0-.2,0-.39,0-.59s0-.39,0-.59a1.88,1.88,0,0,1,.92-1.75l2.13-1.22-4-6.91-2.12,1.23a1.92,1.92,0,0,1-2-.07,10.47,10.47,0,0,0-1-.6,1.89,1.89,0,0,1-1.05-1.68V312h-8v2.44a1.89,1.89,0,0,1-1,1.68,10.47,10.47,0,0,0-1,.6,1.92,1.92,0,0,1-2,.07l-2.12-1.23-4,6.91,2.12,1.22a1.88,1.88,0,0,1,.92,1.75c0,.2,0,.39,0,.59s0,.39,0,.59a1.9,1.9,0,0,1-.92,1.76ZM38,326a6.53,6.53,0,1,1,6.52,6.53A6.52,6.52,0,0,1,38,326Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.22,
    width: 1,
    height: 83.77,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.81 111.81 103.47 116.95 49.97 116.95 47.63 111.81 70.41 96.04 83.03 96.04 105.81 111.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.61 80.85 83.03 96.04 70.41 96.04 68.83 80.85 84.61 80.85",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.81 111.81 103.47 116.95 49.96 116.95 47.63 111.81 105.81 111.81",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.57,
    width: 1,
    height: 67.18,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.16 95.21 173.82 100.36 120.31 100.36 117.98 95.21 140.76 79.45 153.38 79.45 176.16 95.21",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.96 64.26 153.38 79.45 140.76 79.45 139.18 64.26 154.96 64.26",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.15 95.22 173.81 100.36 120.31 100.36 117.98 95.22 176.15 95.22",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.08,
    y: 273.67,
    width: 39.99,
    height: 38.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.07,
    y: 273.67,
    width: 15.2,
    height: 38.43,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.08 292.89 363.07 292.89 331.84 293.88 323.08 292.89",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.07 307.46 323.08 307.46 354.31 308.45 363.07 307.46",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.08 282.15 348.41 282.15 325.89 282.96 323.08 282.15",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.07 301.81 337.74 301.81 360.26 302.61 363.07 301.81",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.67 277.87 361.25 277.87 356.48 278.36 332.67 277.87",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.97 297.01 355.54 297.01 350.78 297.49 326.97 297.01",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.54 285.81 363.07 285.81 366.38 287.1 344.54 285.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.97 285.81 336.51 285.81 339.82 287.1 317.97 285.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.76 303.08 323.22 303.08 319.91 304.37 341.76 303.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.07 298.69 377.95 298.69 381.27 299.99 363.07 298.69",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.27 292.89 379.81 292.89 378.27 291.83 368.27 292.89",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.54 387.11 421.73 387.11 425.53 312.11 299.74 312.11 303.54 387.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.1,346.48H308.94l-1.44-26.11H414.78Zm-103.21-1H412.16l1.55-24.11H308.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.69,376.44H311.93l-1.17-23.58h102.4Zm-98.81-1h97.87l1.35-21.58H311.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,336.29H350.89l-.82-6.36h23.77Zm-21.25-1h20.38l.56-4.36h-21.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,367.82H350.89l-.82-6.35h23.77Zm-21.25-1h20.38l.56-4.35h-21.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.93 387.11 318.78 395.28 316.47 411.69 311.96 411.69 311.96 387.11 319.93 387.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.93 387.11 318.78 395.28 311.96 395.28 311.96 387.11 319.93 387.11",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.34 387.11 406.48 395.28 408.79 411.69 413.31 411.69 413.31 387.11 405.34 387.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.34 387.11 406.48 395.28 413.31 395.28 413.31 387.11 405.34 387.11",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 447.18,
    rx: 203,
    ry: 23.07,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.47 412.48 89.85 412.24 143.23 412.15 250 411.98 356.77 412.15 410.15 412.23 463.53 412.48 410.15 412.72 356.77 412.81 250 412.98 143.23 412.81 89.85 412.72 36.47 412.48",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.63,308.34a41.12,41.12,0,0,0,.8,15.82,44.21,44.21,0,0,0,2.42,7c1.26,2.89,2.58,5.72,2.26,8.88-.3.21.74.18.78-.13,8.46-4.82,19.32-5.7,25.83-13.58,3.08-3.73,4.64-8.46,5.38-13.19.8-5.15,1-10.85-.31-15.93-1.12-4.29-3.63-8.43-7.66-10.53s-9.62-2-14-.63C160.67,289,156,299.19,154.63,308.34Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.29,371q1.72-5.78,3.49-11.54c2.32-7.52,4.74-15,7.41-22.42q2.4-6.64,5.07-13.18a81.57,81.57,0,0,0-1-8.18c-.7-3.28-1.73-6.45-2.69-9.66-.06-.2.26-.3.34-.11,1.9,4.42,4.38,10.08,4.45,15.32q3.09-7.38,6.65-14.56a62.37,62.37,0,0,0-.38-12.13c0-.18.26-.24.29,0a43,43,0,0,1,.83,10.7c1.82-3.59,3.73-7.14,5.77-10.63.19-.32.62,0,.46.32-3.18,6.12-6.13,12.37-8.9,18.71a40.81,40.81,0,0,1,13.27-7.69c.21-.07.37.23.16.32a48.47,48.47,0,0,0-14.36,9.5q-3,7-5.68,14c5.29-5.19,12.54-8.6,19.55-10.43.24-.07.3.3.07.37-8.11,2.44-14.41,7-20.58,12.56q-1.08,2.86-2.11,5.73c-2.62,7.25-5.09,14.56-7.47,21.89q-1.71,5.28-3.36,10.56c-1.18,3.8-2.11,7.81-3.65,11.47-.15.35-.77.27-.69-.15A107.69,107.69,0,0,1,150.29,371Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.32,300.94a20.91,20.91,0,0,1,3.05,7.59.06.06,0,0,1-.12,0,65.13,65.13,0,0,0-3.3-7.45C163.82,300.87,164.18,300.72,164.32,300.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.42,318.57A22.26,22.26,0,0,1,187,316c.07,0,.11.09,0,.12-1.22.51-2.51.86-3.74,1.34s-2.45,1-3.71,1.49A.22.22,0,0,1,179.42,318.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.68,297.36a14.34,14.34,0,0,1,2.44-1.51.13.13,0,0,1,.14.21,14.19,14.19,0,0,1-2.41,1.56C183.7,297.72,183.52,297.46,183.68,297.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.1,337.09c6.09,1.81,12.22,3.48,18.32,5.27.52.16,10.83-19.59,7.11-29.76a33.26,33.26,0,0,0-20.72-19.66c-4.35-1.48-9.71-2.72-14.3-1.7-4.09.9-7,4.25-8.31,8.09-1.81,5.23-1.2,11.46-.22,16.79a29.44,29.44,0,0,0,6,13.71C117.22,333.68,121.35,335.68,126.1,337.09Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,318.32a81.27,81.27,0,0,0,12,4.71,49.22,49.22,0,0,1,8,2.89c-2.57-5.74-5.4-11.36-8.4-16.93-3.93-1.14-8.07-2.92-11-5.7A.17.17,0,0,1,118,303c3.25,2.3,6.83,3.67,10.42,5.23q-1.21-2.25-2.46-4.49c-.23-.42.34-.83.62-.43a129.17,129.17,0,0,1,8.66,14.55,66.69,66.69,0,0,0,.62-13.33.09.09,0,0,1,.18,0,44.14,44.14,0,0,1-.15,14.64c2.14,4.27,4.09,8.64,5.84,13.07.69-2.66,1.6-5.28,2.2-8a36.48,36.48,0,0,0,.87-11.73.09.09,0,0,1,.18,0,41.4,41.4,0,0,1-2.56,21.54c1,2.67,2,5.34,2.88,8a159.62,159.62,0,0,1,8.09,42.29.26.26,0,0,1-.51,0,210.36,210.36,0,0,0-9.08-41.8c-1.77-5.31-3.81-10.47-6-15.53-3.6-1.07-7.19-2.51-10.72-3.74a33.4,33.4,0,0,1-9.88-4.84C117,318.44,117.14,318.26,117.26,318.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.58,312.59c3.73,1.32,7.26,3.18,11,4.52.18.07.08.34-.1.31-3.94-.82-7.85-2-11-4.62C111.32,312.7,111.45,312.54,111.58,312.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,304.54c-.05-.19.24-.31.3-.1,1,3.43,1.73,7.08.74,10.59a.14.14,0,0,1-.27,0C142.61,311.48,142.81,308,142,304.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.61,296.61a9.09,9.09,0,0,1,1.62,5.84c0,.13-.21.21-.25.05-.45-2-1.21-3.76-1.81-5.66A.25.25,0,0,1,126.61,296.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.6,345.8c-1.78,5.67-6,13.51-12.76,13.57-4.35,0-8.74-.47-13.11-.54-4.68-.07-9.37-.06-14,.22-.38,0,.56-14,11.8-20.85,3.16-1.91,7-2.52,10.58-3.29a48.75,48.75,0,0,1,12.5-1.3c2.58.1,4.73.65,5.65,3.29S199.46,343.1,198.6,345.8Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.76,338.7c-2.73.7-5.49,1.51-8.23,2.38a27.88,27.88,0,0,1,2.27-2.21c1.17-1,2.47-1.76,3.73-2.62.11-.07.05-.27-.09-.22a15.45,15.45,0,0,0-6.63,5.27c-3.42,1.11-6.8,2.33-10.06,3.66a38,38,0,0,0-6.45,3.4,26.69,26.69,0,0,1,2.33-4.06c1.5-1.93,3.52-3,5.47-4.38a.17.17,0,0,0-.17-.3,16,16,0,0,0-8.78,9.51,37.25,37.25,0,0,0-6.37,5.79c-7.45,8.45-13.31,19.7-13.33,31.17,0,.27.44.35.49.07a63.71,63.71,0,0,1,14.19-30.48c.54-.62,1.08-1.22,1.64-1.79a50.44,50.44,0,0,1,6.15-.45c2.39,0,4.77.35,7.15.54,3.93.32,8.27.37,11.81-1.61.16-.09.05-.36-.12-.29-7.9,2.87-16.18-.77-24.09.94a36.88,36.88,0,0,1,11.67-7.53l.72-.29c5.07.61,10.42,1.93,15.35.28a.12.12,0,0,0-.06-.23c-4.77,1.19-9.34-.31-14-.55,5.13-2,10.35-3.58,15.49-5.56C194.22,339,194.23,338.58,193.76,338.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,343.69a70.07,70.07,0,0,1-7.38.56c-.05,0-.07.09,0,.1a15.27,15.27,0,0,0,7.44-.48C196.17,343.84,196.12,343.67,196,343.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.34,338.82a12.36,12.36,0,0,0-3.65,2.54c-.13.12.05.35.19.24.62-.45,1.25-.87,1.9-1.29a18.9,18.9,0,0,0,1.77-1.12A.22.22,0,0,0,179.34,338.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.63,357.08c.09.19-.18.37-.29.17h0a.26.26,0,0,1-.17.11,112.84,112.84,0,0,1-13.74,2.4c-3.72.33-8,.54-11.26-1.62-4.41-2.93-7.31-10.75-4.93-15.71,2.82-5.9,11.32-2.7,15.59-.6A31.25,31.25,0,0,1,139.63,357.08Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.93,359.81a43.45,43.45,0,0,0-8.2-6.24,28,28,0,0,0-8.32-8.48c-.16-.11-.3.14-.15.26a37.63,37.63,0,0,1,7,7.37A77.61,77.61,0,0,0,123,348a13.72,13.72,0,0,0-5.53-5.54s-.11,0-.06.07a22.94,22.94,0,0,1,5,5.24c-2.09-.78-4.2-1.5-6.31-2.2-.19-.07-.26.22-.08.29,3.75,1.47,7.6,3,11.32,4.81a43.79,43.79,0,0,1-13.71,0,.1.1,0,0,0-.06.19,27,27,0,0,0,14.55.22,68.14,68.14,0,0,1,6.9,3.86,17.31,17.31,0,0,0-5.57.46,42.66,42.66,0,0,1-9.81,1.11c-.12,0-.15.2,0,.22,5.69,1,11.07-1.61,16.7-.93a43.52,43.52,0,0,1,5.87,4.79,44.05,44.05,0,0,1,8.56,12.08c2.37,4.83,3.66,9.94,5.58,14.93a.18.18,0,0,0,.35-.09C155,377.67,150.1,366.82,142.93,359.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.78,346.32a6.47,6.47,0,0,0-1.45-1.76,5.7,5.7,0,0,0-1.68-1.26.06.06,0,0,0-.06.09c.47.53,1.12.92,1.62,1.43s.93,1.1,1.44,1.6A.08.08,0,0,0,125.78,346.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.4,349.37c-.84-.21-1.73-.19-2.59-.37a21.93,21.93,0,0,1-2.51-.75.1.1,0,0,0-.08.19,8.32,8.32,0,0,0,5.18,1.2A.14.14,0,0,0,116.4,349.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.36 375.39 165.61 383.86 163.08 412.48 140.67 412.48 137.5 383.86 136.57 375.39 166.36 375.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.36 375.39 165.61 383.86 137.5 383.86 136.57 375.39 166.36 375.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.35,
    y: 373.07,
    width: 34.23,
    height: 6.88,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "178.3 435.72 171.59 435.72 218.59 247.41 235.3 247.41 178.3 435.72",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.59 247.42 235.3 247.42 222.28 290.43 207.86 290.43 218.59 247.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.35 425.72 236.65 425.72 241.65 247.41 258.35 247.41 243.35 425.72",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.65 247.42 258.35 247.42 254.73 290.43 240.44 290.43 241.65 247.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.7 435.72 315.41 435.72 278.41 247.41 261.7 247.41 308.7 435.72",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.86 290.43 272.43 290.43 261.7 247.42 278.41 247.42 286.86 290.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.43,
    y: 355.05,
    width: 97.52,
    height: 3.68,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.17,
    y: 63.05,
    width: 265.65,
    height: 196.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.45,
    y: 55.24,
    width: 285.11,
    height: 14.53,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.36,
    y: 94.39,
    width: 101.28,
    height: 2.24,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.68,
    y: 99.07,
    width: 66.64,
    height: 2.24,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,118.41l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.2-49.72.15-78.83.24Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,125.54l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.2-49.72.15-78.83.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,132.66l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.2-49.72.15-78.83.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,139.79l87.35-.24c29.11.09,49.72,0,78.83.24-29.11.2-49.72.15-78.83.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,146.91l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.2-49.72.15-78.83.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,154l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.2-49.72.15-78.83.24Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,161.16l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.2-49.72.15-78.83.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,168.28l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.2-49.72.15-78.83.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,175.41l87.35-.24c29.11.09,49.72,0,78.83.24-29.11.2-49.72.14-78.83.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,182.53l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.2-49.72.15-78.83.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,189.65l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.2-49.72.15-78.83.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,196.78l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.2-49.72.15-78.83.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,203.9l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.2-49.72.15-78.83.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,211l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.21-49.72.15-78.83.24Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,218.15l87.35-.23c29.11.08,49.72,0,78.83.23-29.11.2-49.72.15-78.83.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.38,
    y: 200.02,
    width: 13.25,
    height: 26.43,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.96,
    y: 180.03,
    width: 13.25,
    height: 46.43,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.53,
    y: 175.6,
    width: 13.25,
    height: 50.85,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.11,
    y: 162.48,
    width: 13.25,
    height: 63.97,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.68,
    y: 134.53,
    width: 13.25,
    height: 91.92,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.26,
    y: 123.19,
    width: 13.25,
    height: 103.26,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,113.41l.36,28.26.25,28.26c.17,18.84.22,37.68.25,56.52l-.86-.86,42.49,0,42.49.1,42.49.28,34,.51-34,.51-42.49.29-42.49.1-42.49,0h-.87v-.86c0-18.84.08-37.68.25-56.52l.25-28.26Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.38,
    y: 232.43,
    width: 13.25,
    height: 1.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.96,
    y: 232.43,
    width: 13.25,
    height: 1.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.53,
    y: 232.43,
    width: 13.25,
    height: 1.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.11,
    y: 232.43,
    width: 13.25,
    height: 1.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.68,
    y: 232.43,
    width: 13.25,
    height: 1.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.26,
    y: 232.43,
    width: 13.25,
    height: 1.2,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,199.43l-.16-1c.72-.12,73-12.81,130.19-78l.75.66C258.79,186.57,186.19,199.31,185.46,199.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.23 122.89 318.21 118.01 313.49 119.6 317.23 122.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.82,
    y: 102.56,
    width: 32.88,
    height: 38.96,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.44,105.21a1.19,1.19,0,1,1-1.18-1.18A1.18,1.18,0,0,1,361.44,105.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,110.36c3.33-.25,6.65-.27,10-.31s6.65,0,10,.31c-3.32.26-6.65.28-10,.31S353.4,110.62,350.07,110.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,113.44a47.62,47.62,0,0,1,10.85,0,47.62,47.62,0,0,1-10.85,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,116.52c2.31-.24,4.62-.3,6.93-.31s4.62.07,6.93.31c-2.31.24-4.62.3-6.93.31S352.38,116.76,350.07,116.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,119.6c2.89-.24,5.78-.3,8.67-.31s5.78.07,8.67.31c-2.89.24-5.78.3-8.67.31S353,119.84,350.07,119.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,122.68c2.51-.24,5-.3,7.53-.31s5,.06,7.53.31c-2.51.24-5,.3-7.53.31S352.58,122.92,350.07,122.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,125.76c3.22-.26,6.43-.28,9.64-.31s6.43,0,9.64.31c-3.21.25-6.43.27-9.64.3S353.29,126,350.07,125.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,128.83a64.73,64.73,0,0,1,12.45,0,62.66,62.66,0,0,1-12.45,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,131.91c3.33-.25,6.65-.27,10-.31s6.65.06,10,.31c-3.32.26-6.65.28-10,.31S353.4,132.17,350.07,131.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,135c3.33-.25,6.65-.27,10-.31s6.65,0,10,.31c-3.32.26-6.65.28-10,.31S353.4,135.25,350.07,135Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.44,
    y: 146.55,
    width: 38.9,
    height: 46.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.07,152.77a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,146.07,152.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,158.05a30.19,30.19,0,0,1,8.63,0,30.19,30.19,0,0,1-8.63,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,161.52a52.23,52.23,0,0,1,11.18,0,50.56,50.56,0,0,1-11.18,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,165a43.35,43.35,0,0,1,10.35,0,43.35,43.35,0,0,1-10.35,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,168.48a39.14,39.14,0,0,1,5.18-.31,37.37,37.37,0,0,1,5.17.31,43.35,43.35,0,0,1-10.35,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,172a32.82,32.82,0,0,1,9,0,32.82,32.82,0,0,1-9,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,175.43a53.57,53.57,0,0,1,11.51,0,48.17,48.17,0,0,1-5.75.31A50.53,50.53,0,0,1,130.88,175.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,178.9a34.55,34.55,0,0,1,4.75-.31,32.86,32.86,0,0,1,4.75.31,31.5,31.5,0,0,1-4.75.31A33,33,0,0,1,130.88,178.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,182.38a57.35,57.35,0,0,1,11.91,0,57.35,57.35,0,0,1-11.91,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,185.85a59.25,59.25,0,0,1,11.91,0,57.35,57.35,0,0,1-11.91,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.88,158.05a51.73,51.73,0,0,1,11.31,0,51.73,51.73,0,0,1-11.31,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.88,161.52a23.21,23.21,0,0,1,7.44,0,22.47,22.47,0,0,1-7.44,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.88,165a45.8,45.8,0,0,1,10.64,0,45.8,45.8,0,0,1-10.64,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.88,168.48a39.14,39.14,0,0,1,5.18-.31,37.37,37.37,0,0,1,5.17.31,43.35,43.35,0,0,1-10.35,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.88,172a51.73,51.73,0,0,1,11.31,0,51.73,51.73,0,0,1-11.31,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.88,175.43a32.82,32.82,0,0,1,9,0,29.6,29.6,0,0,1-4.5.31A30.94,30.94,0,0,1,147.88,175.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.88,178.9a43.26,43.26,0,0,1,5.32-.31,41.17,41.17,0,0,1,5.32.31,39.46,39.46,0,0,1-5.32.31A41.37,41.37,0,0,1,147.88,178.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.88,182.38a27.47,27.47,0,0,1,8.23,0,27.47,27.47,0,0,1-8.23,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.88,185.85a26.15,26.15,0,0,1,7.9,0,25.32,25.32,0,0,1-7.9,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.29,
    y: 85.31,
    width: 19.78,
    height: 19.78,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.36,87.32a1.18,1.18,0,1,1-1.18-1.18A1.18,1.18,0,0,1,341.36,87.32Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.7,445.19c2,.64,58.32-.09,60.45-1.48.82-.52,1.19-8.73,1.35-18.67v-.32c0-2,.07-4.15.07-6.29,0-.3,0-.59,0-.88.08-14.35-.14-29.24-.14-29.24l-37.7.38,1.14,29,0,1.15.23,6,0,.62s-21.44,9.92-23.62,11.7S347.72,444.56,349.7,445.19Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.63,429.26c.15,0,.22-.09.23-.13Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.7,445.19c2,.64,58.32-.09,60.45-1.48.73-.46,1.1-7,1.29-15.43-10.32,2.15-50.34,10.25-51.43,6.82-.43-1.34,3-3.67,5.15-5-5.91,2.82-12.46,6.05-13.61,7C349.39,438.88,347.72,444.56,349.7,445.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.09,445.1c12.68-.3,24.12-.78,25.06-1.39.73-.46,1.1-7,1.29-15.43-1.46.3-3.53.73-6,1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,226s-8.46,95.21-9.84,102.48c-.32,1.66-.52,10.66-.65,22.22-.29,25.24-.11,70.76-.11,70.76H372.68s1.17-78.87,2.93-93.38,13-102.08,13-102.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.47,414.54c6.2-.13,4.42-.18,10.62-.24,3,0,23-.2,25.8.27.06,0,.06.12,0,.13-2.84.47-22.77.29-25.8.26-6.2-.06-4.42-.11-10.62-.24A.09.09,0,1,1,374.47,414.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.85,369.46q.06-8.65.13-17.29c0-5.58,0-11.16.3-16.74.53-11.28,2.82-22.38,4.45-33.54s3-22.37,4.22-33.59c1.38-12.58,2.6-25.19,3.89-37.78,0-.08.15-.08.14,0-1.87,22.49-4,45-7.07,67.32q-1.17,8.34-2.54,16.65c-.93,5.6-1.85,11.21-2.29,16.88s-.51,11.11-.56,16.68l-.18,17.27c-.12,12.79-.24,32.47-.37,45.26a.19.19,0,0,1-.38,0C404.68,399.16,404.76,380.86,404.85,369.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.37,226s-16.83,95.21-18.21,102.48c-.32,1.66-.52,10.66-.65,22.22v0L393.58,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.82,448.55c2,.5,58.17-4.22,60.2-5.76.77-.57.56-8.79,0-18.72l0-.31c-.1-2.05-.23-4.16-.37-6.29l-.06-.88c-.93-14.32-2.21-29.15-2.21-29.15l-37.58,3.05,3.19,28.8.12,1.14.65,6,.07.61s-20.69,11.42-22.74,13.35S393.81,448.06,395.82,448.55Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.83,448.55c2,.5,58.16-4.22,60.19-5.76.66-.49.61-6.56.24-14.5-8.7,2.22-50.62,12.76-51.9,9.3-.27-.74.62-1.82,1.83-2.88a95.61,95.61,0,0,0-9.1,5.64C395.07,442.28,393.81,448.06,395.83,448.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.14,423.61l39.69-1.68s-10.84-87.08-11-92.43c-.29-8-4.11-40.8-7.31-67.39,0,0,6.07-14.4-5.3-36.14h-45.6s3.05,20.69,8.29,33.81A61.21,61.21,0,0,1,407,264.41s4.54,59.28,4.71,66.68C412.05,345.71,418.14,423.61,418.14,423.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.2,416.34c6.19-.39,4.4-.37,10.59-.69,3-.16,22.94-1.18,25.79-.83a.07.07,0,0,1,0,.13c-2.81.59-22.74,1.26-25.77,1.36-6.19.2-4.42.07-10.61.21C419.09,416.52,419.08,416.34,419.2,416.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.14,258.88A76.52,76.52,0,0,1,407,264.41a.14.14,0,0,1-.11.25c-4-1.72-8.07-3.37-12-5.3A.26.26,0,0,1,395.14,258.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.86,231.45c0-.14.26-.17.26,0a131.3,131.3,0,0,0,.67,13.36c.18,2.06,1.84,13.44,5.41,12.61.6-.14.9-.73,1-1.63a14.45,14.45,0,0,0-.48-3.49c-.39-2.38-.71-4.77-.92-7.18a65.21,65.21,0,0,1,.15-13.47.12.12,0,0,1,.23,0,124.08,124.08,0,0,0,1.09,18.58c.44,3,1.94,7.42-1.16,7.88s-5.19-7-5.58-9.05A68.34,68.34,0,0,1,393.86,231.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.11,257.7a19.86,19.86,0,0,1,.8,2.36,5.42,5.42,0,0,1,.33,1.94c0,.13-.18.14-.24.06a6.8,6.8,0,0,1-.83-1.89c-.28-.73-.56-1.46-.81-2.19A.4.4,0,0,1,400.11,257.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.7,183.53a.44.44,0,0,0,.31.48l1.7.15c1.7-4.21,3.49-7.55,3-6.24a23.76,23.76,0,0,0-1.33,6.39l3.36.26c1.63-7.46,3.56-13,3.38-11.26-.71,6.9-.42,9.13-.07,11.51,8.1.59,18.73,1.24,26.43,1.54,1.06-4.12,2-8.58,2.15-8.26a22.5,22.5,0,0,1,1,8.37c2.45.07,4.42.08,5.61,0,0,0,.72-3.47.85-4.61a25.67,25.67,0,0,0-.5-8.74,43.73,43.73,0,0,0-3.23-8.16.16.16,0,0,0,0-.06s0,0,0,0a25.16,25.16,0,0,1-1.83-5.45s0,0,0,0a25.68,25.68,0,0,1-.47-4.16c-.14-5.12-2.65-9.6-7.09-11.06-8.12-8.73-16.77-5.34-19.6,1.15-.27.63-.54,1.36-.81,2.15v0c-1,2.93-1.92,6.74-2.76,9.69h0s0,0,0,0h0a29,29,0,0,1-1.15,3.39C383.22,166,378.2,168.87,376.7,183.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.83,145.66a9.41,9.41,0,0,1,4.89,7.89,26.71,26.71,0,0,0,.92,6.38,22.74,22.74,0,0,0,3.16,5.67,16.81,16.81,0,0,1,3.49,9.25,30.35,30.35,0,0,1-1.49,11.55s0,0,0,0a31.94,31.94,0,0,0,.89-12.06c-.48-4.06-2.52-6.66-4.58-9.79a17.18,17.18,0,0,1-2.88-8.33,21.62,21.62,0,0,0-.66-5.52,10.47,10.47,0,0,0-3.93-4.66C411.39,145.87,411.61,145.53,411.83,145.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.41,166.27c2.2-2.85,4.46-5.26,5.83-8.83,1.24-3.25,2-6.69,3.28-9.94,0-.05.1,0,.08,0-2,5.77-2.56,11.62-6.27,16.42-2,2.61-4,5-5.4,8.18a30.43,30.43,0,0,0-2.41,10.46c0,.12-.16.11-.17,0A25,25,0,0,1,380.41,166.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.17,187.4c-8.54,19.8-21.2,40-27.87,43.35-4.68,2.37-13.94,2.22-17-3.19-6.61-11.8-8.93-30.71-7.31-40.49.58-3.48,19-4.92,20.42-1.42,3.29,8.19,4.35,16.68,5.39,16.68.89,0,5.72-6.61,16.59-18.17C404.75,172.1,406.16,180.47,403.17,187.4Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.78,190.2s.32-10.31,4-17.18c2.54-4.75,9.21-14.46,25.26-15.15,3.81-.16,9.35,2.31,3.23,4.83-4.35,1.8-7.65,1.62-10,3.12,0,0,6.68,4,6.69,7.8a71.37,71.37,0,0,1-.68,10,15.5,15.5,0,0,1-1.88,0s-.1,3.58-4.09,7.29Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.91,168.88c2.64-1,8.26-3,13.44-3.09,5.76-.07,16.86,1.36,16.86,5.61,0,3.11-4.28,2.94-4.28,2.94s4.46,1.56,3.85,4.37c-.56,2.57-3.87,2.24-3.87,2.24s2.55,1.41,1.53,3.77c-1.21,2.85-6.35-.57-10.08,1.24C374.53,186.37,357.91,168.88,357.91,168.88Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.41,171.88a22.89,22.89,0,0,1,13.46,2.36c.1.06.11.16,0,.13a56.61,56.61,0,0,0-13.47-2.44S370.38,171.89,370.41,171.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.64,177.69a25.73,25.73,0,0,1,13.3,3.15c.1.06.1.17,0,.14a60,60,0,0,0-13.3-3.24A0,0,0,0,1,370.64,177.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.27,226.3l-5.77-26.08A234.36,234.36,0,0,1,395,181.91c9.38-8.11,13.85-7.24,8.23,7.2S389.33,220.27,382.27,226.3Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.27,226.3l-5.77-26.08A234.36,234.36,0,0,1,395,181.91c9.38-8.11,13.85-7.24,8.23,7.2S389.33,220.27,382.27,226.3Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.76,199.66q1.5,5.34,2.6,10.76.56,2.73,1.05,5.48c.33,1.86.53,3.74.81,5.61,0,.1-.12.11-.14,0-.67-3.66-1.48-7.3-2.22-10.94s-1.49-7.27-2.22-10.9C379.62,199.62,379.74,199.59,379.76,199.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.28,193.92c-.2.47-.4.93-.58,1.4a3,3,0,0,1,0-.31,7.32,7.32,0,0,1,.5-1.8A3.46,3.46,0,0,1,401.28,193.92Zm-16.07-.52a6.36,6.36,0,0,0,0,1.85,7.25,7.25,0,0,0,.51-3.64A6.36,6.36,0,0,0,385.21,193.4Zm5.25,18.67a6.43,6.43,0,0,0,0,1.86,6.06,6.06,0,0,0,.5-1.79,6.43,6.43,0,0,0,0-1.86A6.45,6.45,0,0,0,390.46,212.07Zm-6.2-8.08a6.43,6.43,0,0,0-1.86,0,6.06,6.06,0,0,0,1.79.5,6.43,6.43,0,0,0,1.86,0A6.45,6.45,0,0,0,384.26,204Zm19.07-24.41a6.43,6.43,0,0,0-1.86,0,6.06,6.06,0,0,0,1.79.5,6.43,6.43,0,0,0,1.86,0A6.45,6.45,0,0,0,403.33,179.58Zm-6.78,24.64s0,.08,0,.11,0,0,0,0A.23.23,0,0,0,396.55,204.22Zm-14.81,10.94a6.25,6.25,0,0,0,1.3,1.32,6.54,6.54,0,0,0-.92-1.61,6.29,6.29,0,0,0-1.3-1.33A6.79,6.79,0,0,0,381.74,215.16Zm10.34-16.24a6.55,6.55,0,0,0,1.33-1.3,7.17,7.17,0,0,0-2.94,2.21A6.51,6.51,0,0,0,392.08,198.92Zm2.83-11.25a6.55,6.55,0,0,0,1.3,1.33,6.51,6.51,0,0,0-.91-1.61,6.6,6.6,0,0,0-1.31-1.33A6.54,6.54,0,0,0,394.91,187.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.21,189.11c-5.62,14.43-13.88,31.16-20.94,37.19l-2.38-10.74,25.34-38C406.19,179.11,405.66,182.82,403.21,189.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,232.65s18,4.27,52.18,1.32c0,0-13.36-42.62-24.11-54.11-4.9-5.23-9.68-4.43-13.73-1.07-1,.84-13.56,16.76-14.62,22.3-.94,4.9,3.05,10.35,3.05,10.35Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.22,193.21a6.43,6.43,0,0,1,0,1.86,6.06,6.06,0,0,1-.5,1.79,6.43,6.43,0,0,1,0-1.86A6.55,6.55,0,0,1,401.22,193.21Zm-1.31,32.37a6.43,6.43,0,0,0,0,1.86,6.06,6.06,0,0,0,.5-1.79,6.36,6.36,0,0,0,0-1.85A6.39,6.39,0,0,0,399.91,225.58Zm-8.85,5.52a6.43,6.43,0,0,0,0,1.86,7.11,7.11,0,0,0,.52-3.64A6.77,6.77,0,0,0,391.06,231.1Zm28.67-25.25a6.43,6.43,0,0,0,0,1.86,6.73,6.73,0,0,0,.5-1.79,6.8,6.8,0,0,0,0-1.86A7,7,0,0,0,419.73,205.85Zm-29.27,6.22a6.43,6.43,0,0,0,0,1.86,6.06,6.06,0,0,0,.5-1.79,6.43,6.43,0,0,0,0-1.86A6.45,6.45,0,0,0,390.46,212.07Zm19.82-13.54a6.36,6.36,0,0,0-1.85,0,7.07,7.07,0,0,0,3.64.52A6.73,6.73,0,0,0,410.28,198.53Zm10.63,18.05a6.43,6.43,0,0,0-1.86,0,6.06,6.06,0,0,0,1.79.5,6.43,6.43,0,0,0,1.86,0A6.45,6.45,0,0,0,420.91,216.58Zm-17.7-1.49a6.43,6.43,0,0,0-1.86,0,6.73,6.73,0,0,0,1.79.5,6.8,6.8,0,0,0,1.86,0A6.73,6.73,0,0,0,403.21,215.09Zm32.11,16.58a6.43,6.43,0,0,0-1.86,0,6.73,6.73,0,0,0,1.79.5,6.8,6.8,0,0,0,1.86,0A6.84,6.84,0,0,0,435.32,231.67Zm-32-52.09a6.43,6.43,0,0,0-1.86,0,6.06,6.06,0,0,0,1.79.5,6.43,6.43,0,0,0,1.86,0A6.45,6.45,0,0,0,403.33,179.58ZM412,185a6.81,6.81,0,0,0,1.3,1.33,6.4,6.4,0,0,0-.91-1.62,6.55,6.55,0,0,0-1.3-1.33A6.76,6.76,0,0,0,412,185Zm16.1,23a6.25,6.25,0,0,0,1.3,1.32,6.54,6.54,0,0,0-.92-1.61,6.29,6.29,0,0,0-1.3-1.33A6.79,6.79,0,0,0,428.14,208Zm-30.68-2.15a6.81,6.81,0,0,0,1.3,1.33,6.3,6.3,0,0,0-.92-1.62,6.49,6.49,0,0,0-1.29-1.33A6.57,6.57,0,0,0,397.46,205.84ZM412.8,223a6.2,6.2,0,0,0,1.29,1.32,6.21,6.21,0,0,0-.91-1.61,6.55,6.55,0,0,0-1.3-1.33A6.79,6.79,0,0,0,412.8,223Zm-18.14-35.7c.09.12.17.24.26.35a6.29,6.29,0,0,0,1.29,1.34,6.3,6.3,0,0,0-.92-1.62l-.36-.45Zm-2.58,11.61a6.55,6.55,0,0,0,1.33-1.3,7.17,7.17,0,0,0-2.94,2.21A6.51,6.51,0,0,0,392.08,198.92Zm39,21.39a6.54,6.54,0,0,0,1.33-1.3,7.25,7.25,0,0,0-2.95,2.22A6.6,6.6,0,0,0,431.11,220.31Zm-39.88.67a6,6,0,0,0,1.33-1.29,7.17,7.17,0,0,0-2.94,2.21A6.24,6.24,0,0,0,391.23,221Zm27.54-26.64a6.3,6.3,0,0,0,1.33-1.3,6.24,6.24,0,0,0-1.61.92,6.5,6.5,0,0,0-1.33,1.29A6.51,6.51,0,0,0,418.77,194.34Zm-11.32,38.2a6.29,6.29,0,0,0,1.33-1.3,7.25,7.25,0,0,0-2.95,2.22A6.6,6.6,0,0,0,407.45,232.54Zm3.37-23.49a6.2,6.2,0,0,0,1.32-1.29A7.17,7.17,0,0,0,409.2,210,6.47,6.47,0,0,0,410.82,209.05Zm12.8,18.87a6.3,6.3,0,0,0,1.33-1.3,7.17,7.17,0,0,0-2.94,2.21A6.51,6.51,0,0,0,423.62,227.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.25,189.36A53.71,53.71,0,0,0,390.2,194c.39-.89.75-1.79,1.07-2.72,0,0,0-.06-.07,0-.33.65-.66,1.3-.94,2s-.48,1.22-.71,1.84l0,0a24.31,24.31,0,0,0-2.83,5.85,11.4,11.4,0,0,0,.12,5.74,14.19,14.19,0,0,0,1.12,2.78,8.55,8.55,0,0,0,1.46,2.19c-.34,2-.57,4-.83,5.94a49.48,49.48,0,0,0-.6,5.82.11.11,0,0,0,.21,0c0-.13.08-.27.13-.41s0-.05,0-.07c.42-1.78.6-3.65.85-5.45s.73-5.81.73-5.83-.89-1.64-1.25-2.39a16.8,16.8,0,0,1-1-2.83,10.69,10.69,0,0,1-.12-5.64,27,27,0,0,1,2.65-5.66c1.06-1.9,2.16-3.79,3.25-5.67C393.42,189.38,393.3,189.29,393.25,189.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.63,178.49c-.2.92-4.52,6.94-8.73,6.79-1.37-.05-1.42-7.54-1.42-7.54l-.13-.55-1.82-7.73,9-5.93,1.31-.79s.35,2.14.77,4.82l.06.38c0,.15.06.29.08.44.07.4.13.8.19,1.21s.09.61.13.94.08.65.13,1A51.71,51.71,0,0,1,410.63,178.49Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.64,167.56a15.91,15.91,0,0,1-9.29,9.63l-1.82-7.73,9-5.93,1.31-.79S409.22,164.88,409.64,167.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.06,155.16c-4,13.35,3.58,17.24,6.46,18.09,2.61.77,11.61,3.08,16.94-9.79s.38-18.93-5.51-21S391,141.81,387.06,155.16Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.63,153.42c.32.05.63,0,1,.06a1.6,1.6,0,0,0,1-.13.5.5,0,0,0,.16-.59,1.23,1.23,0,0,0-1.09-.59,1.75,1.75,0,0,0-1.26.31A.53.53,0,0,0,389.63,153.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.85,155.91a8.69,8.69,0,0,1-.86-.44,1.54,1.54,0,0,1-.78-.62.48.48,0,0,1,.16-.58,1.23,1.23,0,0,1,1.24,0,1.81,1.81,0,0,1,.93.92A.53.53,0,0,1,398.85,155.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.82,158.62s.06.07,0,.11c-.3.89-.49,2,.24,2.52,0,0,0,.07,0,.05C395.12,160.86,395.39,159.43,395.82,158.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.91,157.92c1.5.32.74,3.29-.65,3S395.66,157.64,396.91,157.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.45,158.22c.22.24.4.6.7.71s.71-.11,1-.35c0,0,.05,0,0,0-.14.57-.5,1.1-1.13,1s-.85-.67-.84-1.28C397.24,158.26,397.37,158.13,397.45,158.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.76,157.12s-.08,0-.09.06c-.2.93-.58,2-1.49,2.06,0,0,0,0,0,0C390.23,159.4,390.72,158,390.76,157.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.18,156c-1.45-.48-2.31,2.46-1,2.91S391.4,156.36,390.18,156Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.51,156c-.28.09-.59.3-.87.24s-.47-.46-.59-.82c0,0,0,0-.06,0a1.16,1.16,0,0,0,.35,1.46c.46.24,1-.14,1.26-.66C389.66,156.11,389.62,155.93,389.51,156Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,166.19a1.46,1.46,0,0,1-.9.38,2.5,2.5,0,0,1-.95-.44s-.06,0-.05,0a1.29,1.29,0,0,0,1.08.75,1,1,0,0,0,.9-.67C394.09,166.2,394,166.17,394,166.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.85,163.74a3.76,3.76,0,0,0,1.08,1.63,1.69,1.69,0,0,0,1,.4c.79.06,1-.6,1.09-1.21a4.16,4.16,0,0,0,0-1A5,5,0,0,1,390.85,163.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.93,165.37a1.69,1.69,0,0,0,1,.4c.79.06,1-.6,1.09-1.21A1.79,1.79,0,0,0,391.93,165.37Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.05,161.85s-.56,1.32-.73,2c0,.06.13.13.35.2,0,0,0,0,0,0a3.18,3.18,0,0,0,3.29-.34.07.07,0,0,0-.07-.12,4.73,4.73,0,0,1-3,.05c0-.19,1-2.22.93-2.26a6,6,0,0,0-1.55-.06c1.08-2.78,2.6-5.36,3.63-8.14a.09.09,0,0,0-.16-.08,48.46,48.46,0,0,0-4.28,8.59C389.3,162,390.76,161.89,391.05,161.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,163.6c-2.2-.43-1.43-5.09-1.43-5.09s-4.38-1.21-4.07-7.9a10.06,10.06,0,0,0,.49,5.74s-7.49-3-8.94-10.34c0,0,.38,3.65,1.27,5.16a9.33,9.33,0,0,1-3.83-4.87s-2.39,3.35-3.72,4.08c0,0,4.09-13.41,16.2-8.48,0,0,7.69,2.71,8.77,9.7S409.1,163.6,409.1,163.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,168.39a2.58,2.58,0,0,1-.67,0,2.09,2.09,0,0,1-.64-.11,1.78,1.78,0,0,1-.74-.42,2.2,2.2,0,0,1-.43-.5,2.56,2.56,0,0,1-.36-.87l1.5-3.49s3.86-3.65,5.57-2.19S411.46,168,409,168.39Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.21,162.45a0,0,0,0,1,0,.07,5.94,5.94,0,0,0-3.76,3,1.3,1.3,0,0,1,2,.05,0,0,0,0,1-.06.07,1.47,1.47,0,0,0-1.67.18,7.07,7.07,0,0,0-1,1.11c-.11.12-.35,0-.26-.16l0,0C407.83,164.72,410,162.21,412.21,162.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,167.78a.65.65,0,1,1-.35-.85A.65.65,0,0,1,409,167.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.44,167.09a.46.46,0,1,1-.24-.6A.46.46,0,0,1,410.44,167.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.9,182.77c8.92,12.06,25.94,40.62,20.23,46.91-9.39,10.34-32,19.09-39,21-3,.82-13.21-21.39-10.32-23.12,3.46-2.08,27.66-9.48,27.6-11.54,0-1.17-2.56-11-4.64-23.53C409.35,177.92,413.65,177,417.9,182.77Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.81,226.31s-9.12-2.92-15.17-4.55c-3.38-.91-9.31-2-12.09-1.49-4.17.7-21.15,6.28-19.89,10.42,1.15,3.76,15.13-2.89,15.13-2.89s-14.7,5.46-12.49,9.73,17-5.35,17-5.35-15,5.95-12,10c2.24,3.05,16.14-4.9,16.14-4.9s-12.84,5.2-10.67,8.44c2.41,3.58,15.69-3,15.69-3,6.92,7.3,13.2,8,17.72,7.88C400.28,250.62,399.81,226.31,399.81,226.31Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.75,225.59c-1.75.58-3.52,1.15-5.22,1.88s-3.36,1.53-5,2.41a32.21,32.21,0,0,0-6,4.05,68.27,68.27,0,0,1,11.16-6c1.69-.73,3.34-1.55,5-2.28A0,0,0,0,0,372.75,225.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.51,231.65c-2.21.84-4.42,1.59-6.59,2.52s-4.12,2-6.21,3.07c-.16.08-.06.14.11.07,2.12-1,4.17-1.75,6.3-2.71s4.25-2,6.41-2.9C375.56,231.69,375.54,231.64,375.51,231.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.81,236.43a52.33,52.33,0,0,0-9.78,4.62c-.15.09,0,.15.14.07,3.22-1.6,5.74-2.87,9.68-4.57C378.91,236.52,378.88,236.41,378.81,236.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.07,220.9a17,17,0,0,0-3-.9,19.64,19.64,0,0,0-2.93-.47,15.74,15.74,0,0,0-6.31.77,55.93,55.93,0,0,0-11.66,5.31c-.08,0,0,.18.06.15a104.78,104.78,0,0,1,11.49-4.56,17.68,17.68,0,0,1,6.2-1c1.09.06,2.17.22,3.25.38a28,28,0,0,0,2.89.46C381.12,221.09,381.15,220.93,381.07,220.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.34,225.58l-24.75-10.06a232.79,232.79,0,0,1-4.57-25.6c-1.35-12.33,1.9-15.51,10.59-2.69S439.38,216.35,440.34,225.58Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.34,185.41l.33.46a4.56,4.56,0,0,1-.29.83A5.59,5.59,0,0,1,420.34,185.41Zm-.61,20.44a6.43,6.43,0,0,0,0,1.86,6.73,6.73,0,0,0,.5-1.79,6.8,6.8,0,0,0,0-1.86A7,7,0,0,0,419.73,205.85Zm1.18,10.73a6.43,6.43,0,0,0-1.86,0,6.06,6.06,0,0,0,1.79.5,6.43,6.43,0,0,0,1.86,0A6.45,6.45,0,0,0,420.91,216.58Zm5.36-19.35a6.08,6.08,0,0,0,1.78.5l.28,0-.3-.51A6.1,6.1,0,0,0,426.27,197.23ZM412,185a6.81,6.81,0,0,0,1.3,1.33,6.4,6.4,0,0,0-.91-1.62,6.55,6.55,0,0,0-1.3-1.33A6.76,6.76,0,0,0,412,185Zm16.1,23a6.25,6.25,0,0,0,1.3,1.32,6.54,6.54,0,0,0-.92-1.61,6.29,6.29,0,0,0-1.3-1.33A6.79,6.79,0,0,0,428.14,208Zm3,12.32a6.54,6.54,0,0,0,1.33-1.3,7.25,7.25,0,0,0-2.95,2.22A6.6,6.6,0,0,0,431.11,220.31Zm-12.34-26a6.3,6.3,0,0,0,1.33-1.3,6.24,6.24,0,0,0-1.61.92,6.5,6.5,0,0,0-1.33,1.29A6.51,6.51,0,0,0,418.77,194.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.25,197.56a12.29,12.29,0,0,1,.9,2.22l.26.77c-.22-1.43-.42-2.86-.62-4.29,0-.1.13-.14.15,0,.62,3.24,3.5,18.41,3.63,19.2.07,0,.84.44.89.44s0,.16-.06.12-1-.44-1-.45c-.32-.69-2.59-12.27-2.8-13.68a.82.82,0,0,1-.09-.19l-.23-.6c-.14-.37-.26-.75-.39-1.12a15.16,15.16,0,0,1-.72-2.35C411.17,197.54,411.23,197.51,411.25,197.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.05,212.74a22.93,22.93,0,0,1,2.9.86c1,.3,1.93.58,2.88.9,1.85.6,3.67,1.26,5.49,1.93a116.89,116.89,0,0,1,10.79,4.5.07.07,0,0,1-.06.13c-3.73-1.3-7.4-2.78-11.1-4.16l-5.46-2c-.91-.34-1.82-.7-2.73-1a29.19,29.19,0,0,1-2.75-1C416,212.8,416,212.73,416.05,212.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.79,143.91c.1,1.54,7.46,5.21,12.7,1.23s3-11.8-4.19-11C412.75,134.67,408.58,140.63,408.79,143.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.11,138.14a9.08,9.08,0,0,0-4-4.43,5.48,5.48,0,0,0-5.47,0,11.24,11.24,0,0,0-4,4.32,16.39,16.39,0,0,0-1.23,2.81,8.25,8.25,0,0,0-.57,3,7.42,7.42,0,0,1,0-3.18,13.9,13.9,0,0,1,1-3.07,10.62,10.62,0,0,1,4.25-4.92,6.31,6.31,0,0,1,3.29-.84,6.45,6.45,0,0,1,3.2,1A8,8,0,0,1,424.11,138.14Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.25,448.79c-2.06.66-60.7-.1-62.91-1.54-.85-.54-1.24-9.09-1.41-19.44v-.32c0-2.13-.07-4.33-.07-6.55,0-.31,0-.62,0-.92l2.85-30.43,39.23.4-3.87,30.13-.05,1.2-.23,6.24,0,.64s22.32,10.33,24.59,12.18S162.31,448.14,160.25,448.79Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.25,448.79c-2.06.66-60.7-.1-62.91-1.54-.85-.54-1.24-9.09-1.41-19.44v-.32c0-2.13-.07-4.33-.07-6.55,0-.31,0-.62,0-.92l38.21.1-.05,1.2-.23,6.24,0,.64s22.32,10.33,24.59,12.18S162.31,448.14,160.25,448.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.26,448.79c-1.06.34-17,.3-32.57,0l-9.21-.22c-11.11-.3-20.28-.76-21.14-1.32s-1.23-8.84-1.4-19c0-.14,0-.28,0-.43v-.33h0l37.8.07,0,.65s22.32,10.32,24.58,12.17S162.31,448.13,160.26,448.79Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.62,446.51c-9.89-.37-49.78-.94-59.58-.55-.08,0-.08.06,0,.06,9.79.58,49.69.82,59.57.65C159.82,446.67,159.82,446.52,159.62,446.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,427.72c-3.88-.78-8.65-.24-11.66,2.49-.12.11,0,.27.16.23A54.63,54.63,0,0,1,138,428.21.25.25,0,0,0,138,427.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.76,429.45c-3.88-.78-8.64-.24-11.65,2.49-.12.11,0,.27.16.23a54.51,54.51,0,0,1,11.47-2.23A.25.25,0,0,0,140.76,429.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.55,431.18c-3.88-.78-8.65-.25-11.66,2.49-.11.1,0,.27.17.23a54.38,54.38,0,0,1,11.47-2.23A.25.25,0,0,0,143.55,431.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.69,448.78l-9.21-.22c-11.11-.3-20.28-.76-21.14-1.32s-1.23-8.84-1.4-19c0-.14,0-.28,0-.43v-.33h0C101.15,431.11,119.39,443.26,127.69,448.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.34,427.69H94.1s8.51-98.65,8.18-100.37c-.42-2.21-2.92-12.19-6.24-25.23-1-4.09-2.16-8.46-3.33-13-3.14-12.27-6.62-25.69-9.64-37.36C78.53,234.25,75,220.67,75,220.67h35.79s4.17,13.22,9.43,30.43c8.57,28,20,66.44,21.14,75.8C143.18,342,136.34,427.69,136.34,427.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.47,420.48c-6.45-.13-4.6-.19-11-.25-3.16,0-23.9-.21-26.85.28a.07.07,0,0,0,0,.13c3,.49,23.69.31,26.85.28,6.45-.06,4.6-.12,11-.25A.1.1,0,0,0,134.47,420.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.22,321.29c-1.38-6.1-3.45-12.09-5.25-18.08q-5.49-18.27-11-36.51-2.78-9.12-5.57-18.24c-.95-3.07-1.89-6.14-2.85-9.2s-2-6-2.86-9c-.34-1.23-.53-.56-.09,1,.89,3.15,1.77,6.31,2.69,9.45q2.73,9.33,5.49,18.66,5.49,18.56,11.08,37.09,2.79,9.3,5.59,18.59a77.38,77.38,0,0,1,2.29,9,41.83,41.83,0,0,1,.37,9.62c-.41,6.46-1.15,12.91-1.75,19.36l-1.8,19.38Q104.73,391.68,103,411q-.23,2.44-.42,4.89c0,.55.79.51.84,0,1.39-12.71,2.46-25.47,3.65-38.2s2.38-25.34,3.56-38c.3-3.18.64-6.37.64-9.56A39.4,39.4,0,0,0,110.22,321.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72,220.67c-2.49,19.22-7.22,55.27-10.68,81.42C88,270.4,75,220.67,75,220.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.51,449.36c-2.06.67-60.7.12-62.92-1.32-.85-.53-1.27-9.08-1.48-19.43v-.32c0-2.13-.09-4.33-.1-6.55,0-.31,0-.62,0-.92-.14-14.93.94-30.43.94-30.43l38.33.25L89.2,420.79l0,1.19L89,428.22l0,.64s22.35,10.25,24.62,12.09S117.56,448.69,115.51,449.36Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.51,449.36c-2.06.67-60.7.12-62.92-1.32-.85-.53-1.27-9.08-1.48-19.43v-.32c0-2.13-.09-4.33-.1-6.55,0-.31,0-.62,0-.92l38.2,0,0,1.19L89,428.22l0,.64s22.35,10.25,24.62,12.09S117.56,448.69,115.51,449.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.51,449.36c-2.06.67-60.7.12-62.92-1.32-.85-.53-1.27-9.08-1.48-19.43v-.32L89,428.22l0,.64s22.35,10.25,24.62,12.09S117.56,448.69,115.51,449.36Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.87,447.08c-9.89-.34-49.78-.76-59.58-.34-.08,0-.08.06,0,.06,9.79.55,49.69.65,59.58.44C115.07,447.23,115.08,447.08,114.87,447.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.16,428.37c-3.89-.77-8.65-.21-11.65,2.53-.11.11,0,.27.17.23a54.36,54.36,0,0,1,11.46-2.27A.25.25,0,0,0,93.16,428.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,430.08c-3.88-.76-8.65-.21-11.65,2.54-.11.1,0,.27.17.23a55.15,55.15,0,0,1,11.46-2.28A.25.25,0,0,0,96,430.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.74,431.8c-3.88-.76-8.64-.21-11.64,2.54-.12.1,0,.27.16.23a54.5,54.5,0,0,1,11.46-2.28A.25.25,0,0,0,98.74,431.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.62,220.67s-.82,17.12-4.74,30.69c-.32,1.12-.66,2.22-1,3.28a63.41,63.41,0,0,0-10.32,5.3s-.41,13.78-.83,29.15c-.45,17.18-.93,36.34-.83,40.4.36,15.21-1.9,98.82-1.9,98.82l-42.23.17s7.64-93.37,7.58-98.94c-.08-9,2.05-48.53,3.69-77.39,1-17.78,1.83-31.48,1.83-31.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.53,420.79c-6.45-.1-4.6-.16-11-.2-3.16,0-23.9-.11-26.85.39-.06,0-.06.13,0,.14,2.95.47,23.7.2,26.85.16,6.46-.09,4.6-.14,11-.3A.1.1,0,0,0,88.53,420.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4,226.79c-.78,23.55-1.6,47.11-2.66,70.66s-2.48,47.25-4.46,70.82c-1.1,13.17-2.14,31.69-3.56,44.83,0,.09.12.12.13,0,3.08-23.37,4.79-52.26,6.31-75.78s2.53-47.07,3.33-70.61c.46-13.32.8-26.65,1.2-40C64.7,226.58,64.4,226.6,64.4,226.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.61,253.62a78.76,78.76,0,0,0-12.07,6.32.14.14,0,0,0,.13.25c4.07-2,8.23-3.88,12.19-6.09A.27.27,0,0,0,105.61,253.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,239.09c-.28,1.5-.64,3-1,4.48s-.53,2.83-.9,4.21a7.2,7.2,0,0,1-2,3.53c-.55.51-1.15,1-1.74,1.43-.31.25-.65.49-1,.75,0-.2.07-.4.11-.61.1-.57.2-1.14.29-1.7.21-1.27.42-2.53.61-3.8.38-2.49.73-5,1.25-7.47,0-.1-.13-.14-.15,0-.62,2.44-1.31,4.86-1.85,7.32-.26,1.21-1.21,7.18-1.25,7.6s-.08.87-.1,1.31a5.46,5.46,0,0,0,0,1.34.11.11,0,0,0,.2,0h0a5.26,5.26,0,0,0,.38-1.3c.11-.42.21-.85.28-1.29,0-.15,0-.31.07-.47.59-.36,1.14-.83,1.69-1.23s1.19-.85,1.75-1.32a6.67,6.67,0,0,0,2.15-3.35,24.65,24.65,0,0,0,.7-4.28c.19-1.7.33-3.4.56-5.09C106,239,105.87,239,105.85,239.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.72,179.81c6.55,13,23.13,39.36,31.68,39.53,10.69.2,32-15.38,37.33-21.46,2.31-2.65-16.07-20.93-18.79-18.34-3.64,3.47-16,14-16.44,14.18-.91.36-16.67-12.69-26.15-21.11C87.73,163.18,85.77,170,90.72,179.81Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.65,202.07s8-6.53,13.09-11c2.82-2.52,7.27-7.27,8.49-10.06,1.83-4.19,6.82-22.86,2.32-24.17-4.07-1.18-6.32,15.4-6.32,15.4s3.75-16.53-1.42-17.06-5.22,18.56-5.22,18.56,3.47-17.08-1.94-16.77c-4.1.23-5.11,17.51-5.11,17.51s2.88-14.7-1.34-14.65c-4.66.06-6.6,15.95-6.6,15.95-10.7,2-14.91,7-17.51,11.1C132.45,187.83,154.65,202.07,154.65,202.07Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.3,178c.51-1.93,1-3.88,1.38-5.84s.6-3.95.76-5.93a35.24,35.24,0,0,0-.14-7.8c.27,4.63-.83,11.69-1.17,13.65s-.57,3.94-.91,5.91C171.21,178,171.28,178,171.3,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.18,176.91c.54-2.49,1.18-4.94,1.61-7.46s.63-4.91.89-7.43c0-.2-.09-.14-.12,0-.36,2.51-.89,4.81-1.28,7.32s-.68,5-1.16,7.51C164.11,176.94,164.17,176.94,164.18,176.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.9,177.07a57.26,57.26,0,0,0,1.6-11.58c0-.2-.13-.11-.15.08-.46,3.86-.79,6.9-1.58,11.46C157.76,177.11,157.88,177.15,157.9,177.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.27,186.31l15.47,25.19s-19.08,10.23-26.32,8.36S96.15,194.79,90,179.92s1.54-13.73,7.54-8.67,26.66,21.79,27,21.75S132.27,186.31,132.27,186.31Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.11,201.87c-1-1.83-2.06-3.62-3.1-5.42-.51-.87-1-1.74-1.54-2.58s-1.08-1.9-1.72-2.77a.06.06,0,0,0-.1.06c.4,1,1,2,1.43,2.92s.92,1.78,1.38,2.66c1,1.84,1.95,3.68,3,5.5,2,3.65,4.17,7.22,6.35,10.78a.08.08,0,0,0,.13-.08C139,209.21,137.13,205.52,135.11,201.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.36,193a44.46,44.46,0,0,0-5,4.27c-.85.83-1.68,1.69-2.48,2.57s-1.57,1.89-2.38,2.81a.08.08,0,0,0,.11.11c.84-.85,1.76-1.63,2.63-2.45s1.73-1.64,2.58-2.47c1.71-1.66,3.1-2.88,4.74-4.6C124.66,193.07,124.5,192.85,124.36,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.31,219.41a15.35,15.35,0,0,1-6.89.45C114.17,218,96.15,194.79,90,179.92a31,31,0,0,1-2.13-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.81,244.61c.15.15,62-2.21,62.54-2.89.73-.95-18-66-25-73.86-1.49-1.67-10.27-3.53-14.84.95C63.73,183.35,55.26,244.06,55.81,244.61Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.08,186.34c0-.11.14-.17.18-.07,1,2.54,2,5.11,2.89,7.7,0-.38-.08-.75-.11-1.12-.08-1-.07-2-.16-2.94,0-.09.15-.09.15,0,0,1,.24,2,.39,3s.25,1.8.41,2.7c0,.16,0,.32.07.47,1.5,4.3,7.13,24.06,9.25,31.88,1.19,4.41,2.24,8.85,3.23,13.31a.08.08,0,0,1-.15,0c-2.29-7.74-4.51-15.5-6.79-23.24C109.34,211,103.37,190.69,102.08,186.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,170.6s0,0,0,0c.37,2.8,1,9.29-3.4,9.2a9.46,9.46,0,0,1-4.9-2,25.27,25.27,0,0,1-4-3.53,36,36,0,0,1-3.82-4.63c0-.07-.15,0-.1.09,1.16,1.64,2.16,3.36,3.48,4.9a21.64,21.64,0,0,0,4.31,3.91,9.37,9.37,0,0,0,5.21,2,3.56,3.56,0,0,0,3.42-2.93A15.83,15.83,0,0,0,95,170.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55,176.8c-3.14.53-8.81-5-10.65-9a64.35,64.35,0,0,1,1-6.39c.33-2.05.65-4.33.79-6.44l13,4.08a33.66,33.66,0,0,0-1.81,8,4.89,4.89,0,0,0,0,.87s0,.09,0,.15C94.1,169.77,94.59,176.29,91.55,176.8Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.93,168s0,.09,0,.15a7.94,7.94,0,0,1-1.37,0c-7.76-.82-9.22-9.67-9.49-13l12.63,4a34.14,34.14,0,0,0-1.82,8A4.89,4.89,0,0,0,93.93,168Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.89,141.14c-.8,4.85,3.45,18,7.16,20.53,5.39,3.71,13.3,3.07,16.23-3.19,2.83-6.07-3-23.08-7.08-25.31C89.22,129.88,80.07,134,78.89,141.14Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6,147.44s-.06.07,0,.1c.29.88.49,1.94-.23,2.48a0,0,0,0,0,0,0C94.29,149.63,94,148.23,93.6,147.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.52,146.76c-1.46.32-.7,3.23.66,2.92S93.75,146.48,92.52,146.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.64,146.11s.09,0,.09.06c.21.91.6,1.91,1.49,2,0,0,0,.05,0,.06C99.2,148.34,98.7,147,98.64,146.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2,145c1.42-.49,2.29,2.38,1,2.83S98,145.37,99.2,145Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,145.73a10.13,10.13,0,0,0,1-.69c.39-.27.73-.44.91-.9a.65.65,0,0,0-.3-.72,1.56,1.56,0,0,0-1.57.25,2.35,2.35,0,0,0-1,1.3A.68.68,0,0,0,91,145.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.94,143.2c-.42,0-.81,0-1.23,0a2,2,0,0,1-1.26-.24.64.64,0,0,1-.16-.76,1.59,1.59,0,0,1,1.44-.68,2.28,2.28,0,0,1,1.59.5A.67.67,0,0,1,99.94,143.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,155.86a1.36,1.36,0,0,0,.89.33,2.35,2.35,0,0,0,.91-.48,0,0,0,0,1,0,0,1.27,1.27,0,0,1-1,.79,1,1,0,0,1-.92-.61C94.69,155.88,94.75,155.84,94.79,155.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,152.92a3.18,3.18,0,0,0,2.4.83,3.94,3.94,0,0,0,1.11-.24l.21-.08.19-.08a.22.22,0,0,0,.12-.25h0l0-.09h0l0-.08c-.16-.7-.5-1.73-.5-1.73.28.06,1.73.3,1.61-.05a47.45,47.45,0,0,0-3.61-9c0-.09-.2,0-.16.07.81,2.87,2.12,5.57,3,8.44a5.56,5.56,0,0,0-1.56-.06c-.09.06.7,2,.74,2.31a0,0,0,0,1,0,0,4.34,4.34,0,0,1-3.43-.15C95,152.79,95,152.87,95,152.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,153.27a3.69,3.69,0,0,1-1.16,1.51,1.71,1.71,0,0,1-1,.32c-.77,0-1-.66-1-1.26a4.12,4.12,0,0,1,.1-.94A4.9,4.9,0,0,0,98,153.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.88,154.78a1.71,1.71,0,0,1-1,.32c-.77,0-1-.66-1-1.26A1.74,1.74,0,0,1,96.88,154.78Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.52,151.69c3.34-.76,2.62-7,2.62-7s5.52-2.23,5.39-6.73c0,0,6.22,2.25,10.15-.26s1.94-7.14,1.24-8.07-2.65,1.52-2.65,1.52-.88-2.67-1.68-2.79-1.21,1.72-1.21,1.72a36.6,36.6,0,0,0-10.9.65c-5,1.27-6.31,6.86-6.31,6.86s-2.55,1.17-3,3.24S79.4,152.18,81.52,151.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.28,137.19a7.33,7.33,0,0,1,0,2.68,4.84,4.84,0,0,1-1.14,2.31,7,7,0,0,1-2.16,1.5c-.4.17-.83.32-1.26.47s-.87.23-1.31.37c.45,0,.91-.11,1.37-.16s.89-.22,1.33-.37a6.24,6.24,0,0,0,2.36-1.51,4.6,4.6,0,0,0,1.14-2.56A5.61,5.61,0,0,0,89.28,137.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.29,138.32a8.46,8.46,0,0,1,1.12-4.2,6.79,6.79,0,0,1,3.21-2.78,9.56,9.56,0,0,1,1-.39l1.06-.26c.72-.13,1.45-.17,2.18-.24s1.48,0,2.21,0,1.48.14,2.22.19c-.73-.15-1.46-.27-2.2-.41s-1.49-.1-2.24-.15a11.41,11.41,0,0,0-4.42.83,6.82,6.82,0,0,0-3.32,3A7.54,7.54,0,0,0,78.29,138.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.37,152.91a4.34,4.34,0,1,1,3.38-6h0a4.32,4.32,0,0,1-3.38,6Zm-1.17-8a4.16,4.16,0,0,0-.9.25,3.76,3.76,0,1,0,.9-.25Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,150.28c-1.65.24-3.39-1.22-4-3.41a5.16,5.16,0,0,1,.1-3.17,2.7,2.7,0,0,1,4.47-1.2,5.15,5.15,0,0,1,1.67,2.69c.62,2.32-.27,4.57-2,5Zm-1.61-7.93-.21.05a2.28,2.28,0,0,0-1.51,1.5,4.57,4.57,0,0,0-.08,2.82c.53,2,2.12,3.33,3.53,2.94s2.13-2.31,1.59-4.32a4.64,4.64,0,0,0-1.47-2.39A2.41,2.41,0,0,0,100.38,142.35Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.74,147.47l-.47-.33c.49-.71,1.77-1.82,3.09-1l-.31.49C96.87,145.9,95.79,147.41,95.74,147.47Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.21,153.49l-.57-.12c.06-.27.6-2.6,1.8-3.14s8-1.74,8.29-1.8l.09.57a77.3,77.3,0,0,0-8.14,1.76C78.89,151.12,78.35,152.85,78.21,153.49Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.23,151.72s-3.7-3.87-5.51-2.48,1.45,7.32,3.89,7.82a2.38,2.38,0,0,0,3-1.75Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7,150.91a0,0,0,0,0,0,.07,6,6,0,0,1,3.65,3.24,1.32,1.32,0,0,0-2-.05s0,.09.06.08a1.44,1.44,0,0,1,1.67.26,7.69,7.69,0,0,1,1,1.16c.09.14.34,0,.26-.14l0,0C83,153.42,81,150.78,78.7,150.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,167.88l-3.23,7.77-9.59-10-2.79,3.14s9.32,15.81,9.39,15.1l3.29-6.7,4.59,4.74-.24-11.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.86,176.12c-.1-1.94-.15-3.9-.35-5.83,0-.07-.11-.1-.13,0-.41,1.87,0,9.29,0,11.06l0,0c-.19-.2-4.26-4.17-4.3-4.11-.71,1.06-3.13,5.94-3.29,6.38-1.48-2.51-7.13-11.64-8.88-14a.07.07,0,1,0-.11.07c1.29,2.65,8.77,14.94,8.88,14.91a74.54,74.54,0,0,0,3.45-7.08c.69.86,4.79,5.33,4.81,5A61.72,61.72,0,0,0,95.86,176.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1,187.12c1,15.93,5.1,45.93,14.48,52.32,10,6.78,38.55,7.72,46.46,7.64,3.35,0,1.42-24.89-2.07-25.71s-28-1.85-30.48-2.94S90.12,195.78,84,183.22C76.9,168.45,71.31,174.17,72.1,187.12Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44,223.24c-1.64-.51-1.38-1.37,1.46-2.45s15-2.94,14-7.13-18.14-1.32-22.74.84-11.27,7.27-11.27,7.27C132.34,221.88,140.68,222.94,147.44,223.24Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.9 239.34 177.73 240.54 185.81 192.89 151.98 191.69 143.9 239.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.56 239.4 179.39 240.6 187.48 192.94 153.65 191.75 145.56 239.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,214.24a3.66,3.66,0,0,1-3.69,3.16,3,3,0,0,1-2.89-3.4,3.67,3.67,0,0,1,3.7-3.16A3,3,0,0,1,171,214.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,247.09c9.72-.05,21.82.48,31.25-5.13a5.42,5.42,0,0,0,2.36-2.66c4.27-2.44,4.4-5.19,4.4-5.19,3.28-3.49,3-6.31,3-6.31s5-2.92,3.72-6.23c-1.41-3.7-8.13,1.12-13.44,1.51-12.19.91-29.76-1.22-33.29-1.31Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.08,233a77.35,77.35,0,0,0,10.62-1.39,79.1,79.1,0,0,0,11.09-3.86c.11-.05.18.1.08.17a41.54,41.54,0,0,1-21.77,5.24C149.92,233.16,149.9,233,150.08,233Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.56,240.43c3.46-.52,9.55-1.47,19.27-6.42,0,0,.07,0,0,.05a37.19,37.19,0,0,1-19.29,6.54C149.36,240.61,149.33,240.47,149.56,240.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.35,244.43c5.86-1.11,9.41-2.55,15.1-5.14,0,0,.07,0,0,.06-6.16,3.62-8.81,4.24-15.13,5.29C149.14,244.68,149.12,244.48,149.35,244.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.78,220.18l1.77,28.74S91,247.34,83,237.85s-12.13-40.47-11.61-53.31,7.11-14.14,12.71-2.3,15.85,34.25,16.36,34.87S120.78,220.18,120.78,220.18Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.65,234.21c-.07-2.08-.18-4.16-.29-6.24-.06-1-.1-2-.19-3s-.1-2.18-.27-3.24a.06.06,0,0,0-.12,0c-.1,1.07,0,2.17,0,3.25s0,2,0,3c0,2.08.05,4.16.13,6.24.14,4.17.41,8.32.73,12.48a.08.08,0,0,0,.16,0C117.79,242.54,117.78,238.38,117.65,234.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.92,243.2a16.85,16.85,0,0,1-8-4.68A21.74,21.74,0,0,1,79,229.64a143.32,143.32,0,0,1-5.39-22.1c-.68-4.26-1.25-8.56-1.59-12.87a.06.06,0,0,0-.12,0q.09,4.61.54,9.15c-.06-.2-.12-.41-.17-.62-.3-1.27-.64-2.53-1-3.8,0-.18-.3-.09-.27.08a36.21,36.21,0,0,0,.8,3.86c.26.93.5,1.93.85,2.86a114.33,114.33,0,0,0,2,11.86c.87,3.85,1.9,7.68,3.14,11.44,1.11,3.34,2.42,6.57,4.93,9.12a17.64,17.64,0,0,0,9.11,4.73A.08.08,0,0,0,91.92,243.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.58,218.93c-2.53-.58-5.09-1-7.65-1.46l-1.83-.3c-.69-.11-1.28-.14-1.62-.83-.6-1.2-1.11-2.46-1.66-3.69-2-4.52-4.09-9-6.23-13.52-.54-1.63-1.06-3.28-1.55-4.92a.07.07,0,1,0-.14,0c.23,1.05.52,2.08.83,3.1q-1.58-3.27-3.24-6.5c-.06-.1-.23,0-.19.08,2,5,4.21,9.94,6.46,14.85,1.14,2.48,2.27,5,3.43,7.43.55,1.17,1.06,2.38,1.65,3.53s1.72,1.07,2.82,1.24c3,.44,5.92.88,8.9,1.14C111.67,219.13,111.68,219,111.58,218.93Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/Growth.065f42dbd58672f07958e75bb693ff69.svg";
export { ForwardRef as ReactComponent };